export async function userMFALogin(email, token) {

    const getEnvironment = () => {
        const isDev = (!process.env.NODE_ENV || process.env.NODE_ENV === "development");
        return isDev ? "development" :
            window.location.href.includes("acceptance") ? "acceptance" :
                "production";
    };

    const ENVIRONMENTS = {
        development: "http://localhost:1337/",
        acceptance: "https://acceptance.okcomply.com/",
        production: "https://my.okcomply.com/"
    };

    const parameters = {
        headers: {
            "content-type": "application/json; charset=UTF-8"
        },
        body: JSON.stringify({
            email: email,
            token: token
        }),
        method: "POST"
    };
    const currentEnvironment = getEnvironment();
    const response = await fetch(`${ENVIRONMENTS[currentEnvironment]}register/user/mfa/login`, parameters);

    return await response.json();
}